module.exports = __webpack_public_path__ + "img/logo-m&a.b9f96d62.png";